<script lang="ts">
    import Tab from "@apps/iloom_customization/components/Tab.svelte";
    import Tabs from "@apps/iloom_customization/components/Tabs.svelte";

    import type TabsManager from "@components/Tabs/TabsManager";

    export let tabsManager: TabsManager;

    const tabs = [
        {
            value: "products",
            name: "商品",
        },
        {
            value: "media",
            name: "設計摘要",
        },
    ];

    const openedTab$ = tabsManager.openedTab$;

    const onClick = (value: string) => {
        tabsManager.openTab(value);
    };
</script>

<Tabs>
    {#each tabs as tab}
        <Tab
            class="gw-cwl-page__tab"
            openedTab={$openedTab$}
            variant="squared"
            {tab}
            {onClick}
        />
    {/each}
</Tabs>

<style lang="postcss">
    :global(.gw-cwl-page__tab) {
        width: 280px;
    }

    @media all and (max-width: 600px) {
        :global(.gw-cwl-page__tab) {
            width: 50%;
        }
    }
</style>
